import React from 'react';
import styled from 'styled-components';
import SearchBarContext from '../context';

const Container = styled.div`
  height: 28px;
  line-height: 28px;
  display: flex;
  cursor: pointer;
`;

const Icon = styled.span`
  position: fixed;
  color: ${props => props.theme.secondaryColor};
  line-height: 28px;
  font-weight: ${props => props.theme.fontWeightBlack};
  font-size: 14px;
`;

const Text = styled.span`
  text-transform: none;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 14px;
  white-space: nowrap;
`;

const Desc = styled(Text)`
  margin-left: 24px;
  color: ${props => props.theme.secondaryColor};
`;

const Query = styled(Text)`
  margin-left: 5px;
  color: ${props => props.theme.bodyColor};
  display: flex;
  overflow-x: hidden;
`;

const QueryText = styled(Text)`
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

export default function RecentEntries() {
  const { state: { value, query }, dispatch } = React.useContext(SearchBarContext);

  const performSearch = q => e => {
    e.preventDefault();
    dispatch({ type: 'search', payload: q });
  };

  return (
    <Container onClick={performSearch(query)}>
      <Icon className="icon-lw icon-lw-magnifying-glass" />
      <Desc>Search for</Desc>
      <Query>
        {'\u201c'}
        <QueryText>{value}</QueryText>
        {'\u201d'}
      </Query>
    </Container>
  );
}
